import { Box, IconButton } from '@mui/material';
import { DatePicker } from 'react-rainbow-components';
import { useTranslation } from 'react-i18next';
import { Namespace } from '../../../locales/translations';
import { Value } from 'react-rainbow-components/components/DatePicker';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { FiltersActions, selectDateRange } from '../../../store/reducers/awareness_campaigns/filters';
import CloseIcon from '@mui/icons-material/CloseRounded';

const DateRangeFilter = () => {
    const { t, i18n: { language } } = useTranslation([Namespace.ADDRESSES]);
    const dispatch = useAppDispatch();
    const dateRange = useAppSelector(selectDateRange);

    const handleDateChange = (value: Value | undefined) => {
        dispatch(FiltersActions.setDateRange({ date: value }));
    };

    const handleClearFilter = () => {
        dispatch(FiltersActions.clearDateFilter());
    }

    return (
        <Box flexGrow={1} position="relative">
            <DatePicker
                placeholder={t('filter_by_deadline', { ns: Namespace.ADDRESSES }).toString()}
                value={dateRange.date}
                onChange={handleDateChange}
                selectionType="range"
                labelAlignment="left"
                className="datepicker-range"
                style={{ width: '100%' }}
                locale={language}
            />
            {dateRange.date && (
                <Box position="absolute" top={0} right={0} display="flex" alignItems="center" gap={1}>
                    <IconButton onClick={handleClearFilter}>
                        <CloseIcon fontSize='small' />
                    </IconButton>
                </Box>
            )}
        </Box>
    );
};

export default DateRangeFilter; 